import React from "react";
import { Edit, Save, Trash2, X } from "lucide-react";
import EditFloatingActions from "./EditFloatingActions";

const OperatorCardActions = ({
    editing = false,
    onEdit,
    onSave,
    onCancel,
    onDelete,
    disabled = false,
    className = "",
    stopPropagation = false,
    idleExtras = null,
}) => {
    const wrapClick = (handler) => (event) => {
        if (stopPropagation) event.stopPropagation();
        handler?.(event);
    };

    return (
        <>
            <div
                className={`operator-card-actions ${editing ? "is-editing" : "is-idle"} ${className}`.trim()}
                onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
            >
                {editing ? (
                    <>
                        <button
                            type="button"
                            className="operator-card-action is-primary-save"
                            onClick={wrapClick(onSave)}
                            title="Зберегти"
                            aria-label="Зберегти"
                            disabled={disabled}
                        >
                            <Save size={16} />
                        </button>
                        {onCancel ? (
                            <button
                                type="button"
                                className="operator-card-action is-cancel"
                                onClick={wrapClick(onCancel)}
                                title="Скасувати"
                                aria-label="Скасувати"
                                disabled={disabled}
                            >
                                <X size={16} />
                            </button>
                        ) : null}
                    </>
                ) : (
                    <>
                        <button
                            type="button"
                            className="operator-card-action is-primary-edit"
                            onClick={wrapClick(onEdit)}
                            title="Редагувати"
                            aria-label="Редагувати"
                            disabled={disabled}
                        >
                            <Edit size={16} />
                        </button>
                        {onDelete ? (
                            <button
                                type="button"
                                className="operator-card-action is-delete"
                                onClick={wrapClick(onDelete)}
                                title="Видалити"
                                aria-label="Видалити"
                                disabled={disabled}
                            >
                                <Trash2 size={16} />
                            </button>
                        ) : null}
                        {idleExtras}
                    </>
                )}
            </div>
            {editing ? (
                <EditFloatingActions onSave={wrapClick(onSave)} onCancel={wrapClick(onCancel)} disabled={disabled} />
            ) : null}
        </>
    );
};

export default OperatorCardActions;
